import script from "./message.vue?vue&type=script&lang=ts&setup=true"
export * from "./message.vue?vue&type=script&lang=ts&setup=true"

import "./message.vue?vue&type=style&index=0&id=eba4b288&lang=scss&scoped=true"

import exportComponent from "/Users/chanjack/Desktop/历史/iot-app-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eba4b288"]])

export default __exports__